export default __webpack_public_path__ + "static/media/dance-floor.5d79e830.jpg";